// A convenience deterrent only: public images remain downloadable.
const installed = Symbol.for('theme.imageSaveDeterrent');

if (!document[installed] && !window.Shopify?.designMode) {
  document[installed] = true;

  const discourageSaving = (event) => {
    const image = event.target;
    if (
      image instanceof HTMLImageElement &&
      image.matches('.product-media__image') &&
      image.closest('[data-image-save-deterrent]')
    ) {
      event.preventDefault();
    }
  };

  // Delegate from a stable ancestor so deferred and replaced images stay covered.
  document.addEventListener('contextmenu', discourageSaving);
  document.addEventListener('dragstart', discourageSaving);
}
